const hostname = window.location.hostname;
const origin = window.location.origin;

const { REACT_APP_ENV } = process.env;

const getSettings = () => {
  console.log("REACT_APP_ENV", REACT_APP_ENV);
  switch (REACT_APP_ENV) {
    case "local":
      return require("./local.settings.json");
    case "development":
      return require("./dev.settings.json");
    case "productionlocal":
      return require("./prod.local.settings.json");
    default:
      return require("./prod.settings.json");
  }
};

const current_settings = getSettings();
// REACT_APP_ENV === "development"
//   ? require("./dev.settings.json")
//   : REACT_APP_ENV === "productionlocal"
//   ? require("./prod.local.settings.json")
//   : require("./prod.settings.json");

const cookieDomain = hostname.endsWith(".coachsafely.org")
  ? ".coachsafely.org"
  : ".playsafelysports.com";

export const awsConfig = {
  ...current_settings.awsConfig,
  cookieStorage: {
    ...current_settings.awsConfig.cookieStorage,
    domain: cookieDomain,
  },
  oauth: {
    ...current_settings.awsConfig.oauth,
    redirectSignIn: origin,
    redirectSignOut: origin,
  },
};

export const HOST = current_settings.HOST;
export const PLATFORM_HOST = current_settings.PLATFORM_HOST;
export const BACKGROUND_HOST = current_settings.BACKGROUND_HOST;

export const ALLOW_IMGCACHE = false;

export const stripe_public_key = current_settings.stripe_public_key;

export const mapboxgl_accessToken = current_settings.mapboxgl_accessToken;
